import ClockoutController from '../../../core/clockout.controller';
import Inherit from '../../../core/inherit';
import HeaderDelegate from './header.delegate';

class HeaderController extends Inherit(ClockoutController, HeaderDelegate) {
    state = {
        user: {},
        dropdownOpen: false,
        drawerOpen: false,
        activeItem: ''
    };

    async initialize() {
        // Initialize user state from props
        if (this.props.user) {
            this.setUser(this.props.user);
        }
        // Set active item based on current route
        const location = window.location.pathname;
        this.setActiveItemFromRoute(location);
    }

    componentDidUpdate(prevProps) {
        // Update user state when props change (for page reloads)
        if (prevProps.user !== this.props.user) {
            this.setUser(this.props.user || {});
        }

        // Update active item when route changes
        if (this.props.location && prevProps.location?.pathname !== this.props.location.pathname) {
            this.setActiveItemFromRoute(this.props.location.pathname);
        }
    }

    async cleanup() {
        // Cleanup any listeners or timers if needed
    }

    handleUserMenuClick = ({ key }) => {
        if (key === 'logout') {
            this.logout();
        } else if (key === 'account') {
            this.navigateAccount();
        }
    };

    navigateAccount = () => {
        if (this.props.navigate) {
            this.props.navigate('/account');
        } else {
            window.location.href = '/account';
        }
    };

    handleSupportClick = () => {
        // TODO: Implement support functionality
        console.log('Contact Support clicked');
    };

    handleDropdownVisibleChange = (open) => {
        this.setDropdownOpen(open);
    };

    handleMenuClick = () => {
        this.setDrawerOpen(true);
    };

    handleDrawerClose = () => {
        this.setDrawerOpen(false);
    };

    handleDrawerItemClick = (itemKey, route) => {
        this.setActiveItem(itemKey);
        this.setDrawerOpen(false);

        if (route && this.props.navigate) {
            this.props.navigate(route);
        }
    };

    setActiveItemFromRoute = (pathname) => {
        const routeMap = {
            '/dashboard': 'home',
            '/treasury': 'cashflow',
            '/configurations': 'configurations',
            '/billing': 'billing',
            '/team': 'team',
            '/reports': 'reports',
            '/ledger': 'reports',
            '/reconciliation': 'reports'
        };

        const activeItem = routeMap[pathname] || 'home';
        this.setActiveItem(activeItem);
    };

    logout = () => {
        const { removeAuthCookie } = require('../../../utils/cookies');
        removeAuthCookie();
        this.navigateLogin();
    };
}

export default HeaderController;
